<div [formGroup]="filtri">
  <div class="flex flex-wrap align-items-center mb-5 pt-5 gap-3">
    <div>
      <span class="p-input-icon-left p-input-icon-right p-float-label">
        <i class="pi pi-search"></i>
        <input
          type="text"
          id="cercaIscritto"
          class="shadow-4"
          pInputText
          formControlName="stringaFiltro" />
        <label for="cercaIscritto">Cerca Utente</label>
        <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
      </span>
    </div>
    <div>
      <p-dropdown
        formControlName="sezione"
        [showClear]="true"
        [options]="sezioniDropdown"
        optionLabel="nome"
        placeholder="Sezione" />
    </div>
    <p-button
      class="clearFiltri"
      size="small"
      [outlined]="true"
      icon="pi pi-filter-slash"
      (click)="clearFilters()"
      [pTooltip]="translate.instant('tooltip.pulisciFiltri')"
      tooltipPosition="right" />
  </div>
  <div class="flex justify-content-start my-5">
    <p-paginator
      [rows]="pageSize"
      [first]="currentPage"
      [rowsPerPageOptions]="[25, 100, 250, 500]"
      (onPageChange)="pageChange($event)"
      [totalRecords]="totaleDati"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} di {totalRecords}"
      [showPageLinks]="false" />
  </div>
</div>
<p-table
  #dt
  [value]="listaIscrizioni"
  [rowHover]="true"
  (onLazyLoad)="ordinamento($event)"
  [customSort]="true"
  [lazy]="true">
  <ng-template pTemplate="header">
    <tr>
      @for(headerName of headersTabella; track $index){
        <th [pSortableColumn]="rowsTabella[$index]">
          {{ headerName }}
          <p-sortIcon [field]="rowsTabella[$index]"></p-sortIcon>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-iscrizione>
    <tr style="cursor: pointer;" [routerLink]="'/domande_iscrizione/dettaglio_domanda/' + iscrizione.id">
      @for(rowName of rowsTabella; track $index){
        @if(rowName == "domandaData"){
          <td>{{ iscrizione[rowName] | date: 'dd/MM/yyyy' }}</td>
        }
        @else{
          <td>{{ iscrizione[rowName] }}</td>
        }
      }
    </tr>
  </ng-template>
</p-table>
<p-toast position="bottom-center"></p-toast>